import { gql } from '@apollo/client';

export const getPersonsList = gql`
  query LIST_PERSONSAPPLICATIONS(
    $pagination: PaginationInput!
    $selectedTypes: [String!]
    $personStatus: [String!]
    $createdDateFrom: DateTime
    $createdDateTo: DateTime
    $keywordSearch: String
    $OrderBy: OrderByInput
  ) {
    salesforce {
      searchPersons(
        pagination: $pagination
        orderBy: $OrderBy
        selectedTypes: $selectedTypes
        selectedStatuses: $personStatus
        createdOnStart: $createdDateFrom
        createdOnEnd: $createdDateTo
        keyword: $keywordSearch
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          id
          code
          fullName
          title
          type
          email
          phoneDetails {
            phoneType
            phoneNumber
          }
          status
          createdOn
          modifiedOn
          user {
            code
            id
          }
        }
      }
    }
  }
`;

export const getPersonFilters = gql`
  query PERSONS_LISTING_LOVS {
    PersonType: __type(name: "PersonType") {
      name
      enumValues {
        name
      }
    }
    PersonStatus: __type(name: "PersonStatus") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getPersonDetailsInfo = gql`
  query getPersonDetailsInfo($id: String!) {
    salesforce {
      getPersonDetails(id: $id) {
        category
        businessPartner {
          auxiliaryAccount
          code
          createdBy
          createdOn
          fullName
          hasAccessToAllInsured
          id
          isCompany
          isLocal
          isRegistered
          maxCreditLimitAllowed
          maxCreditLimitAllowedCurrency
          modifiedBy
          modifiedOn
          personId
          registerationExpiryDate
          registerationNumber
          relatedCompany
          status
          taxAuxiliaryAccount
          totalCreditLimitReached
          type
        }
        cityOfBirth
        civilRegisterNumber
        civilRegisterPlace
        code
        comments
        companyName
        countryOfBirth
        createdBy
        createdOn
        dateOfBirth
        dateOfDeath
        dateOfDeathNotified
        dateOfEmployment
        dateOfKYC
        dateOfSelfCertificateReceived
        dateOfSelfCertificateValidated
        email
        employer
        fatherName
        financialReference
        firstName
        fullName
        gender
        height
        id
        initials
        isTaxable
        lastName
        maidenName
        managerName
        maritalStatus
        middleName
        modifiedBy
        modifiedOn
        motherName
        occupationClass
        passportNumber
        profession
        professionEntity {
          description
          id
        }
        registrationDate
        registrationPlace
        relation
        relativeOf
        relative {
          fullName
        }
        remarks
        salary
        smoker
        spouseFullName
        spouseProfession
        status
        taxResidenceCountry
        title
        type
        userId
        weight
        phoneDetails {
          phoneType
          phoneNumber
        }
        legalRepresentative {
          fullName
          dateOfBirth
          nationality
        }
        firstNationality {
          id
          code
          title
        }
        secondNationality {
          id
          code
          title
        }
        user {
          code
        }
        occupation {
          id
          code
          title
        }
        personTaxResidenceCountry {
          id
          code
          title
        }
        registrationPlaceCountry {
          code
          id
          title
        }
        legalRepresentativeNationality {
          id
          code
          title
        }
        personTitle {
          id
          code
          title
        }
        nationalityId
        placeOfBirthCountry {
          code
          createdOn
          id
          modifiedOn
          title
        }
      }
    }
  }
`;

export const getPersonDetailsAddressList = gql`
  query getPersonDetailsAddressList(
    $personId: String!
    $pagination: PaginationInput!
    $OrderBy: OrderByInput
  ) {
    salesforce {
      getPersonAddressList(
        personId: $personId
        pagination: $pagination
        orderBy: $OrderBy
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          addressType
          createdBy
          createdOn
          id
          isPrimary
          modifiedBy
          modifiedOn
          personId
          status
          address {
            addressDetails
            addressDetailsArabic
            building
            city
            country
            street
            zone
          }
          country {
            code
            id
            title
          }
          zone {
            code
            id
            title
          }
        }
      }
    }
  }
`;

export const getPersonPartnersList = gql`
  query getPersonPartnersList(
    $pagination: PaginationInput!
    $OrderBy: OrderByInput
    $personId: String!
    $keywordSearch: String
  ) {
    salesforce {
      getPersonPartnersList(
        keyword: $keywordSearch
        pagination: $pagination
        orderBy: $OrderBy
        personId: $personId
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          createdBy
          createdOn
          dateOfBirth
          id
          modifiedBy
          modifiedOn
          name
          nationality
          nationalities {
            id
            code
            title
          }
          personId
          sharePercentage
        }
      }
    }
  }
`;

export const getPersonAuthorizedSignatoryList = gql`
  query getPersonAuthorizedSignatoryList(
    $pagination: PaginationInput!
    $OrderBy: OrderByInput
    $personId: String!
    $keywordSearch: String
  ) {
    salesforce {
      getPersonAuthorizedSignatoryList(
        pagination: $pagination
        orderBy: $OrderBy
        personId: $personId
        keyword: $keywordSearch
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          createdBy
          createdOn
          dateOfBirth
          id
          modifiedBy
          modifiedOn
          name
          nationality
          personId
          nationalities {
            id
            code
            title
          }
        }
      }
    }
  }
`;
